import { Box, BreadcrumbProps, Flex, StackProps, useBreakpointValue } from "@chakra-ui/react";

import AppBreadcrumbs from "@/components/shared/AppBreadcrumbs";
import LeftDrawerHeaderControl from "@/components/shared/LeftDrawerHeaderControl";
import RightDrawerHeaderControl from "@/components/shared/RightDrawerHeaderControl";

function TopBar({
  hideBreadcrumbs,
  breadcrumbsOmitIndexList = [],
  height = 10,
}: {
  hideBreadcrumbs?: boolean;
  breadcrumbsOmitIndexList?: ReadonlyArray<number>;
  height?: number;
}) {
  const topBarStyles = useBreakpointValue<StackProps>(
    {
      base: {
        position: "absolute",
        top: 0,
        left: 0,
        borderBottomWidth: "1px",
        w: "100vw",
        h: height,
      },
      xl: {
        position: "relative",
      },
    },
    { ssr: false }
  );
  const breadcrumbStyles: BreadcrumbProps = {
    overflow: "auto",
    mb: { xl: 2 },
    css: {
      msOverflowStyle: "none",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  };

  return (
    <Flex alignItems="center" {...topBarStyles}>
      <LeftDrawerHeaderControl />
      {!hideBreadcrumbs ? (
        <AppBreadcrumbs flex={1} omitIndexList={breadcrumbsOmitIndexList} {...breadcrumbStyles} />
      ) : (
        <Box flex={1} />
      )}
      <RightDrawerHeaderControl />
    </Flex>
  );
}

export default TopBar;
